module.exports = __webpack_public_path__ + "static/media/tom-klein.edff6a9b.jpg";